export default __webpack_public_path__ + "resources/icons/d330-5f29.png";